/** Same-tab Fitness writers invalidate any previously reviewed draft, including
 * a write that restores identical bytes or a writer mounted and closed again. */
const lifetimes = new Map<string, { revision: number; active: number }>();
const state = (owner: string) => {
  let value = lifetimes.get(owner);
  if (!value) { value = { revision: 0, active: 0 }; lifetimes.set(owner, value); }
  return value;
};
export function fitnessDraftWriterState(owner: string): Readonly<{ revision: number; active: number }> {
  return { ...state(owner) };
}
export function notifyFitnessDraftWrite(owner: string): void { state(owner).revision++; }
export function mountFitnessDraftWriter(owner: string): () => void {
  const value = state(owner); value.active++; value.revision++;
  let mounted = true;
  return () => { if (mounted) { mounted = false; value.active--; value.revision++; } };
}
